import { GridFilterInputValueProps } from '@mui/x-data-grid-premium'
import uniq from 'lodash/uniq'
import { useState } from 'react'
import { useSearchSystemCoreData } from '@omnea-app/fe-core-data/useSystemCoreData'
import {
  getGridListAutocompleteFilterOperator,
  ListAutocompleteFilter,
  SearchAutocompleteFilter,
} from '@omnea-app/fe-tables/ControlledTable/components/AutocompleteInputFilter'
import { useGetTags } from '@omnea-app/fe-tags/useGetTags'
import { useListWorkflows, WorkflowsQueryData } from '@omnea-app/fe-workflow-builder/useListWorkflows'
import { getSupportedOperators } from '@omnea-app/packages/backend/filtering/types/supportedOperators'
import { RequestDisplayStatus } from '@omnea-app/packages/universal/requests/calculateRequestDuration'
import { RequestPriorityEnum } from '@omnea-app/packages/universal/requests/requestPriority'

const ENUM_SERVED_OPERATORS = getSupportedOperators({ type: 'scalar', scalarType: 'enum' })

const REQUEST_PRIORITIES = Object.values(RequestPriorityEnum)

const REQUEST_STATUSES = Object.keys({
  pending: true,
  completed: true,
  rejected: true,
  paused: true,
} satisfies Record<RequestDisplayStatus, true>)

const selectWorkflowTitles = ({ workflows }: WorkflowsQueryData) => uniq(workflows.map(({ title }) => title))

const WorkflowTitleInput = (props: GridFilterInputValueProps) => {
  const { data: titles = [] } = useListWorkflows({ includeArchived: true, select: selectWorkflowTitles })

  return <ListAutocompleteFilter {...props} options={titles} />
}

const TagInput = (props: GridFilterInputValueProps) => {
  const { data } = useGetTags()

  return <ListAutocompleteFilter {...props} options={(data?.tags ?? []).map(({ name }) => name)} />
}

const DepartmentInput = (props: GridFilterInputValueProps) => {
  const [search, setSearch] = useState(props.item.value ?? '')
  const { data: departments = [], isFetching } = useSearchSystemCoreData({
    coreDataType: 'department',
    search,
    includeArchived: true,
  })

  return (
    <SearchAutocompleteFilter
      {...props}
      options={uniq(departments.map(({ name }) => name))}
      loading={isFetching}
      onSearchChange={setSearch}
    />
  )
}

const PriorityInput = (props: GridFilterInputValueProps) => <ListAutocompleteFilter {...props} options={REQUEST_PRIORITIES} />

const StatusInput = (props: GridFilterInputValueProps) => <ListAutocompleteFilter {...props} options={REQUEST_STATUSES} />

export const WORKFLOW_TITLE_FILTER_OPERATORS = getGridListAutocompleteFilterOperator(WorkflowTitleInput)
export const TAGS_FILTER_OPERATORS = getGridListAutocompleteFilterOperator(TagInput)
export const DEPARTMENT_FILTER_OPERATORS = getGridListAutocompleteFilterOperator(DepartmentInput)

export const PRIORITY_FILTER_OPERATORS = getGridListAutocompleteFilterOperator(PriorityInput).filter((operator) =>
  ENUM_SERVED_OPERATORS.includes(operator.value)
)
export const STATUS_FILTER_OPERATORS = getGridListAutocompleteFilterOperator(StatusInput).filter((operator) =>
  ENUM_SERVED_OPERATORS.includes(operator.value)
)
